<template lang="pug">
    .provocative-tests-block(:class="{'provocative-tests-block--re-contact': isReContact, 'provocative-tests-block--addition-only': additionOnly}")
        .provocative-tests-block__row(
            v-for="(item, index) in provocativeTests"
            :key="item.id"
            :class="{old: item.old}"
        )
            .row
                app-datepicker.provocative-tests-block--date(
                    v-model="item.date"
                    label="Дата забора"
                    :error="getFieldError(item, index, 'date')"
                )
                app-select.provocative-tests-block--select(
                    v-model="item.test"
                    :options="testList"
                    searchable
                    label="Название теста"
                    :error="getFieldError(item, index, 'test')"
                )
                app-text-field.provocative-tests-block--result(
                    v-model="item.result"
                    is-float-number
                    label="Результат"
                    :error="getFieldError(item, index, 'result')"
                )
                .app-choice-group.provocative-tests-block--test-result
                    .app-choice-group__label Результат
                    .app-choice-group__list
                        app-choice(
                            v-model="item.testResult"
                            type="radio"
                            label="Нет"
                            :radio-value="0"
                            :disabled="additionOnly"
                        )
                        app-choice(
                            v-model="item.testResult"
                            type="radio"
                            label="Да"
                            :radio-value="1"
                            :disabled="additionOnly"
                        )
                app-text-field.provocative-tests-block--note(
                    v-if="item.testResult"
                    v-model="item.note"
                    label="Заметки"
                )
                app-dropper(
                    :class="{hidden: (isReContact || additionOnly) && item.old}"
                    @click="dropProvocativeTest(index)"
                )
            hr.narrow(v-if="index < provocativeTests.length - 1")
        .br
        app-button(
            plus
            @click="addNewProvocativeTest"
        ) Добавить
</template>

<script>
import { uniqueId } from 'lodash';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
    name: 'provocative-tests-block',

    props: {
        value: {
            type: Array,
            required: true,
        },

        isReContact: {
            type: Boolean,
            required: false,
            default: false,
        },

        additionOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: () => ({
        provocativeTests: [],
    }),

    validations: {
        provocativeTests: {
            $each: {
                date: { required },
                test: { required },
                result: { required },
            },
        },
    },

    computed: {
        testList(){
            return this.$store.getters.provocativeTests;
        },
    },

    watch: {
        provocativeTests(value) {
            this.$emit('input', value);
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.provocativeTests = this.value;
        });
    },

    methods: {
        addNewProvocativeTest() {
            this.provocativeTests.push({
                id: uniqueId(),
                date: '',
                test: '',
                result: '',
                testResult: 0,
                note: '',
            });
            this.$v.$reset();
        },

        dropProvocativeTest(index) {
            this.$confirm({
                message: `Вы действительно хотите удалить показатель?`,
                button: {
                    no: 'Нет',
                    yes: 'Да',
                },
                callback: confirm => {
                    if (confirm) {
                        this.provocativeTests = this.provocativeTests.filter((d, i) => i !== index);
                    }
                },
            });
        },

        getFieldError(item, index, field) {
            if (this.$v.provocativeTests.$each.$iter[index].$dirty && !this.$v.provocativeTests.$each.$iter[index][field].required) {
                return 'Заполните поле';
            }
            return null;
        },

        getFieldsForSave() {
            return this.provocativeTests.map(d => {
                const obj = {
                    date_at: moment(d.date).format('YYYY-MM-DD'),
                    provocative_test_id: d.test.id,
                    result: d.result,
                    test_result: d.testResult,
                    note: d.testResult ? d.note : '',
                };
                return obj;
            });
        },

        getFormattedSavedFields(provocativeTests) {
            let fields = provocativeTests.map(d => ({
                id: d.id,
                date: +moment(d.date_at),
                test: d.provocative_test,
                result: d.result,
                testResult: d.test_result,
                note: d.note || '',
                old: true,
            }));
            fields.sort((f1, f2) => f1.date - f2.date);
            return fields;
        },
    },
};
</script>

<style lang="scss">
.provocative-tests-block {
    .provocative-tests-block {
        &--date {
            width: rem(168px);
        }

        &--select {
            width: rem(438px);
        }

        &--result {
            width: rem(105px);
        }

        &--note {
            width: rem(294px);
        }
    }

    &--re-contact {
        .provocative-tests-block__row.old {
            display: none;
        }
    }

    &--addition-only {
        .provocative-tests-block__row.old {
            .app-text-field, .app-select, .app-datepicker, .app-choice {
                opacity: 0.5;

                pointer-events: none;
            }
        }
    }

    @include mobile_or_P {
        .provocative-tests-block {
            &--date,
            &--select,
            &--result,
            &--test-result,
            &--note {
                width: 100%;
            }
        }
    }
}
</style>
